import { createContext } from 'react';
import { ChatTaskContextType } from '@scale/shared/types/chat';

export const ChatTaskContext = createContext<ChatTaskContextType>({});
